import jwt_decode from 'jwt-decode'
import firebase from 'firebase'
import { authApp } from '~/services/firebase'

export default ({ store, $axios, app, redirect }, inject) => {
  $axios.interceptors.request.use(
    async function(config) {
      let token = store.state.token;
      let domain = store.state.domain;

      let decoded = {}
      if(token) decoded = jwt_decode(token);
      console.log("decoded", decoded);
      let timeNow = new Date().getTime();
      let precautionTimeMs = 1000 * 60 * 15; // 15 minutes
      const currentUser = firebase.auth(authApp).currentUser;
      // A token that belongs to a different uid than the signed-in user is stale
      // (e.g. anonymous token kept after an email-link sign-in) — never send it.
      const uidMismatch = !!currentUser && !!decoded.user_id && decoded.user_id !== currentUser.uid;
      if ((timeNow > decoded.exp * 1000 - precautionTimeMs) || decoded.exp === undefined || uidMismatch) {
        console.log("Token expired, undefined or uid mismatch, refreshing...", { uidMismatch });
        if (currentUser) {
          try {
            const idTokenResult = await currentUser.getIdTokenResult(true);
            console.log("idTokenResult", idTokenResult);
            token = idTokenResult?.token;
          } catch (refreshError) {
            // securetoken.googleapis.com unreachable (corporate proxy/offline):
            // fall back to the SDK's cached token for the CURRENT user rather than
            // failing every request or sending a stale token (Asana 1215474368844464).
            console.error("Token refresh failed, falling back to cached token", refreshError);
            try {
              token = await currentUser.getIdToken(false);
            } catch (cachedError) {
              console.error("No cached token available", cachedError);
              token = uidMismatch ? null : token;
            }
          }
          if (token) store.commit("SET_TOKEN", token);
        } else {
          console.log("No user logged in, skipping token refresh.");
          // Optionally, redirect to login or handle the unauthenticated state
        }
      }

      if (token) config.headers.Authorization = "Bearer " + token;
      if(domain) config.headers['x-tc-domain'] = domain;
      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
}
